export default "<div class=\"alert alert-danger mt-4\" *ngIf=\"err\">\r\n    {{err.errorCode}} ERROR : {{err.message}} \r\n</div>\r\n"